<template>
  <div class="backgroud-white cs-courseSchedule-editor addpayment-editor">
    <div v-if="optionModel.showTitle" class="text-center">
      <h4>{{ isAdd ? "添加支付" : "编辑支付"}}</h4>
    </div>
    <div class="backgroud-gray-popup popup-content-area-small">
      <div v-if="USERMANAGER.isReceptionist" class="addpayment-editor-roleLabel">
        <label class="cs-redLabel">当前账号为前台客服</label>
      </div>
      <div class="paymenttype-list">
        <el-radio-group v-model="dataModel.paymentTypeId">
          <el-row
            :model="paymentTypeGroups"
            v-for="(group, groupIndex) in paymentTypeGroups"
            :key="groupIndex"
          >
            <el-col :span="8" class="cs-paymentType-blank" v-if="paymentTypes.length == 1">
              <span></span>
            </el-col>
            <el-col :span="6" :v-model="group" v-for="(item, itemIndex) in group" :key="itemIndex">
              <el-tooltip effect="light" :content="item.Description" placement="top">
                <el-card shadow="nerver" :body-style="{ padding: '0px' }">
                  <i class="icon" @click="onPaymentTypeIconClick(item.Id)">
                    <img :src="__getImgSrc(item.Name)" />
                  </i>
                  <el-radio name="paymentType" :label="item.Id" @change="checkAllInputs"></el-radio>
                </el-card>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-radio-group>
      </div>
      <div class="payment-inputs">
        <el-form
          ref="dataModel"
          :model="dataModel"
          :rules="rules"
          label-width="100px"
          label-position="right"
        >
          <el-form-item v-if="optionModel.showAccountAmountLeft" class="cs-item-nomargin cs-form-label-row" label="应付价格：">
            <span>{{currency == 1 ? "CNY" : "CAD"}}{{data.accountAmountLeft | toCurrency(currency)}}</span>
          </el-form-item>
          <el-form-item label="付款备注：" prop="comment">
            <el-input
              placeholder="请输入付款备注"
              type="textarea"
              rows="3"
              v-model="dataModel.comment"
              class="input-width"
              @change="checkAllInputs"
            ></el-input>
          </el-form-item>
          <el-form-item label="收款金额：" prop="amount">
            <el-input
              placeholder="请输入收款金额"
              v-model="dataModel.amount"
              class="input-width"
              @change="checkAllInputs"
            ></el-input>
           <span class="cs-color-frenchgrey cs-payment-user">收款人: {{username}}</span>
          </el-form-item>
          
          <el-form-item class="cs-form-label-row" :label="'手续费' + pcRateView + '：'" v-if="hasServiceCharge">
            <span class="input-width">{{pcPrice| toCurrency(currency)}}</span>
          </el-form-item>
          <el-form-item class="cs-form-label-row" label="总计：" v-if="hasServiceCharge">
            <span class="input-width">{{totalPrice| toCurrency(currency)}}</span>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col :span="18" class="footer-left">
          <span v-if="!showError"></span>
          <el-alert
            :closable="false"
            v-if="showError"
            v-bind:title="errorMessage"
            type="error"
            show-icon
          ></el-alert>
        </el-col>
        <el-col class="footer-right" :span="4">
          <el-button
            :disabled="submitBtnDisable"
            :type="submitBtnClass"
            @click="savePaymentModel"
          >确认收款</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
body .popup-content-area-small {
  min-height: 240px;
  padding: 20px 20px 10px 20px;

  // .el-form-item {
  //   span {
  //     height: 40px;
  //     line-height: 40px;
  //   }
  // }

  .cs-item-nomargin{
    margin: 0;
  }

  .addpayment-editor-roleLabel {
    text-align: center;
  }

  .paymenttype-list {
    padding-left: 80px;

    .el-card {
      width: 66px;
      border: 0px;
      background-color: transparent;
    }

    .icon {
      padding: 0;
      width: 64px;
      height: 64px;
      cursor: pointer;

      img {
        vertical-align: top;
        text-align: left;
        width: 64px;
        height: 64px;
      }
    }

    .el-radio-group {
      width: 100%;
      padding: 0;

      .el-radio {
        padding-left: 24px;
        padding-top: 16px;
      }
    }
  }

  .payment-inputs {
    padding: 10px 60px 0px 30px;
  }

  .cs-payment-user{
    display: block;
    line-height: 20px;
  }
}
.el-col {
  button {
    line-height: 8px;
    margin-top: 5px;
    margin-left: 10px;
  }
}
.cs-paymentType-blank {
  span {
    width: 1px;
    height: 1px;
    display: block;
  }
}
</style>
<style>
.addpayment-editor .el-radio .el-radio__label {
  display: none;
}
</style>


<script>
import { getPaymentImgList, getTax, toDecimal } from "../../config/mUtils.js";
import { getGlobalPriceSettingByType } from "../../service/globalPriceSetting.service.js";
import global_ from "@/core/global";
import {
  createAccountModel,
  createAccountPaymentModel,
  getPaymentTypes,
  saveAccountPayment,
} from "../../service/finance.service";

export default {
  props: {
    currency: {
        type: [Number],
        default: 2,
      },
    accountId: {
      type: Number,
      //required: true
    },
    options: {
      showTitle: Boolean,
      allowPaidCount: Number,
      closeOnSaveDisabled: Boolean,
      showAccountAmountLeft: Boolean,
    },
    data: {
      index: Number,
      item: Object,
      accountAmountLeft: Number,
      hasTax: Boolean,
      taxRate: Number
    },
    conditions: {
      paidCount: Number,
      paymentAmount: Number,
    },
  },
  data() {
    let self = this;

    let validateComment = (rule, value, callback) => {
      let message = "";

      let paymentType = self.__findPaymentType(self.dataModel.paymentTypeId);
      if (!value && !!paymentType && paymentType.Name === "emt") {
        message = "该类型必须填写付款备注";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    let validateAmount = (rule, value, callback) => {
      let message = "";
      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);

      if (!isValid) message = "请输入正确的收款金额";

      let amount = isValid ? parseFloat(value) : 0;
      if (!message && amount === 0) message = "收款金额不能为0";

      if (!message && self.optionModel.allowPaidCount > 0) {
        if (
          (self.isAdd &&
            self.conditionModel.paidCount + 1 >=
              self.optionModel.allowPaidCount) ||
          (!self.isAdd &&
            self.conditionModel.paidCount >= self.optionModel.allowPaidCount)
        ) {
          if (amount < self.conditionModel.paymentAmount) {
            message = "收款金额应不小于应付价格";
          }
        }
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      username: "",
      isAdd: false,
      submitBtnClass: "primary",
      submitBtnDisable: false,
      showError: false,
      errorMessage: "",
      priceSettings: {
        paymentCommissionRate: 0,
      },
      paymentImgList: {},
      paymentTypes: [],
      paymentTypeGroups: [],
      dataModel: {
        index: -1,
        id: 0,
        accountId: 0,
        paymentTypeId: 1,
        serviceCharge: 0,
        amount: null,
        tax: 0,
        comment: null,
      },
      optionModel: {
        showTitle: false,
        allowPaidCount: 0,
        showAccountAmountLeft: false,
      },
      conditionModel: {
        paidCount: 0,
        paymentAmount: 0,
      },
      rules: {
        comment: {
          validator: validateComment,
          trigger: "blur",
        },
        amount: [
          {
            required: true,
            message: "收款金额不能为空",
            trigger: "blur",
          },
          {
            validator: validateAmount,
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {},
  computed: {
    hasServiceCharge: function () {
      let paymentType = this.__findPaymentType(this.dataModel.paymentTypeId);
      return !!paymentType ? paymentType.HasServiceCharge : false;
    },
    pcRateView: function () {
      let result = this.priceSettings.paymentCommissionRate * 100 + "%";

      return result;
    },
    pcPrice: function () {
      if (!this.hasServiceCharge) return 0;

      let amount = parseFloat(this.dataModel.amount);
      if (isNaN(amount)) return 0;

      return amount * this.priceSettings.paymentCommissionRate;
    },
    totalPrice: function () {
      let amount = parseFloat(this.dataModel.amount);
      if (isNaN(amount)) return 0;

      if (this.pcPrice === 0) return amount;

      return amount + this.pcPrice;
    },
  },
  created() {
    this.username = window.localStorage.getItem("user_name");
    this.initBasicData();
  },
  mounted() {
    this.reset();
  },
  methods: {
    close() {
      this.$emit("closeDialog");
    },
    checkAllInputs(value, onlyCheck) {
      let isValid = true;

      let $ref = this.$refs["dataModel"];
      if (!!$ref) {
        $ref.validate((valid) => {
          if (!valid) {
            isValid = false;
            return;
          }
        });
      }

      if (onlyCheck) return isValid;

      //this.submitBtnClass = isValid ? "primary" : "info";
      //this.submitBtnDisable = !isValid;

      return isValid;
    },
    async initBasicData() {
      await this.loadPriceSettings();
      this.paymentImgList = getPaymentImgList();
      await this.loadPaymentTypes();
    },
    async loadPriceSettings() {
      let pcRate = this.GLOBAL.globalPriceType.paymentCommissionRate;
      let result = await getGlobalPriceSettingByType(pcRate);
      if (!!result && result.success) {
        this.priceSettings.paymentCommissionRate = result.data.Value;
      }
    },
    reset(
      options = this.options,
      data = this.data,
      conditions = this.conditions
    ) {
      this.reloadOptionModel(options);
      this.reloadDataModel(data);
      this.reloadConditionModel(conditions);
      this.checkAllInputs();
    },
    async loadPaymentTypes() {
      let result = await getPaymentTypes();
      if (!result) return;

      if (result.success) {
        let list = result.data;
        // if (this.USERMANAGER.isReceptionist) {
        //   this.paymentTypes = list.filter(
        //     (i) => i.Name == "emt" || i.Name == "alipay" || i.Name == "wechat"
        //   );
        // } else {
        //   this.paymentTypes = list;
        // }
        this.paymentTypes = list;

        this.paymentTypeGroups = this.__formatPaymentTypeGroups(
          this.paymentTypes
        );
        this.showError = false;
        this.errorMessage = "";

        if (this.USERMANAGER.isReceptionist) {
          let emt = this.paymentTypes.find((i) => i.Name == "emt");
          this.onPaymentTypeIconClick(emt.Id);
        }
      } else {
        this.paymentTypes = [];
        this.paymentTypeGroups = [];
        this.showError = true;
        this.errorMessage = result.message;
      }
    },
    reloadOptionModel(options = this.options) {
      if (!!options) {
        this.showTitle = options.showTitle;
        this.optionModel.allowPaidCount = options.allowPaidCount;
        this.optionModel.showAccountAmountLeft = options.showAccountAmountLeft;
      } else {
        this.optionModel.showTitle = false;
        this.optionModel.allowPaidCount = 0;
        this.optionModel.showAccountAmountLeft = false;
      }
    },
    reloadConditionModel(conditions = this.conditions) {
      if (!!conditions) {
        this.conditionModel.paidCount = conditions.paidCount;
        this.conditionModel.paymentAmount = conditions.paymentAmount;
      } else {
        this.conditionModel.paidCount = 0;
        this.conditionModel.paymentAmount = 0;
      }
    },
    reloadDataModel(data = this.data) {
      this.submitBtnDisable = false;
      if (!!data && !!data.item && data.index >= 0) {
        this.isAdd = false;
        this.dataModel.index = data.index;
        this.dataModel.id = data.item.Id;
        this.dataModel.accountId = data.item.AccountId;
        this.dataModel.paymentTypeId = data.item.PaymentTypeId;
        this.dataModel.serviceCharge = data.item.ServiceCharge;
        this.dataModel.amount = data.item.Amount + data.item.Tax;
        this.dataModel.comment = data.item.Comment;
        this.dataModel.tax = data.item.Tax;
      } else {
        this.isAdd = true;
        this.dataModel.index = -1;
        this.dataModel.id = 0;
        this.dataModel.accountId = this.accountId;
        this.dataModel.paymentTypeId = 1;
        this.dataModel.serviceCharge = 0;
        this.dataModel.amount = null;
        this.dataModel.comment = null;
        this.dataModel.tax = 0;
      }
    },
    savePaymentModel() {
      let isValid = this.checkAllInputs();
      if (!isValid) {
        return;
      }
      
      this.submitBtnDisable = true;
      let totalAmount = parseFloat(this.dataModel.amount);
      let amount = totalAmount;
      let tax = 0;
      if (!!this.data.hasTax){
        tax =  this.getPaymentTax(amount);
        amount -= tax;
      }
      let paymentModel = createAccountPaymentModel();
      $.extend(true, paymentModel, {
        Id: this.dataModel.id,
        AccountId: this.dataModel.accountId,
        PaymentTypeId: this.dataModel.paymentTypeId,
        ServiceCharge: this.pcPrice,
        Amount: amount,
        Tax: tax,
        TotalAmount: totalAmount,
        Comment: this.dataModel.comment,
      });

      this.$emit("callback", {
        success: !this.showError,
        message: this.errorMessage,
        index: this.dataModel.index,
        data: paymentModel,
      });
      if (!this.options.closeOnSaveDisabled) {
        this.close();
        setTimeout(() => {
          this.submitBtnDisable = false;
        }, 1000);
      }
    },
    getPaymentTax(value){
      let tax = 0;
      if (!!this.data && this.data.hasTax){
        tax = getTax(value, this.data.taxRate);
      }
      return tax;
    },
    onPaymentTypeIconClick(typeId) {
      this.dataModel.paymentTypeId = typeId;
      this.checkAllInputs();
    },
    __formatPaymentTypeGroups(models) {
      let modelGroups = [];

      let modelGroup = [];
      for (let i = 0; i < models.length; i++) {
        modelGroup.push(models[i]);
        if (modelGroup.length >= 4) {
          modelGroups.push(modelGroup);
          modelGroup = [];
        }
      }

      if (modelGroup.length > 0) modelGroups.push(modelGroup);

      return modelGroups;
    },
    __findPaymentType(typeId) {
      let result = null;

      for (let i = 0; i < this.paymentTypes.length; i++) {
        let type = this.paymentTypes[i];
        if (type.Id == typeId) {
          result = type;
          break;
        }
      }

      return result;
    },
    __getImgSrc(name) {
      return this.paymentImgList[name];
    },
  },
  watch: {
    options: function (newVal) {
      this.reloadOptionModel(newVal);
    },
    data: function (newVal) {

      this.reloadDataModel(newVal);
      this.checkAllInputs();
      if (this.USERMANAGER.isReceptionist) {
        let emt = this.paymentTypes.find((i) => i.Name == "emt");
        this.onPaymentTypeIconClick(emt.Id);
      }
    },
    conditions: function (newVal) {
      this.reloadConditionModel(newVal);
      this.checkAllInputs();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/paymentEditor.vue